<script>
  import RowsContainer from "../container/RowsContainer.svelte";
  import StepperHeadline from "../stepper/StepperHeadline.svelte";

  import FileSelect from "../ui/FileSelect.svelte";

  export let model;

  const placeholderImage = {
      url: './assets/Hero_Image.png',
      class: 'h-32'
  }

</script>

<div>
  <StepperHeadline>
    <h1>Upload a <span class="text-yellow">hero image</span> (optional)</h1>
    <p>Upload a screenshot or picture of your product or service.<br />Or continue without uploading to quickly use our default image.</p>
  </StepperHeadline>
  <RowsContainer>
    <div class="text-center" />
    <div class="text-center">
      <FileSelect bind:model={model.hero} placeholderImage={placeholderImage} previewMode={1} />
    </div>
    <div class="text-center" />
  </RowsContainer>
</div>




